import React from 'react';

import InvoiceDocument
  from '../quizTypes/InvoiceDocument.jsx';

import InvoiceIdentifyParties
  from '../quizTypes/InvoiceIdentifyParties.jsx';

import InvoiceFieldQuiz
  from '../quizTypes/InvoiceFieldQuiz.jsx';


const RightLessonRenderer = ({
  content,
  lesson,
  step,
  invoice,
}) => {
  if (!content) {
    return null;
  }


  /* =====================================================
     VISUAL FLOW
  ===================================================== */

  if (
    content.type ===
    'visualFlow'
  ) {
    return (
      <div className="conta-primara-visual-flow">

        {content.title && (
          <h2>
            {content.title}
          </h2>
        )}

        <div className="conta-primara-visual-flow-items">

          {content.items?.map(
            (
              item,
              index
            ) => (
              <div
                key={
                  `${item.title}-${index}`
                }
                className="conta-primara-visual-flow-item"
              >

                <div className="conta-primara-visual-flow-icon">
                  {item.icon}
                </div>

                <strong>
                  {item.title}
                </strong>

                <p>
                  {item.description}
                </p>

              </div>
            )
          )}

        </div>

      </div>
    );
  }


  /* =====================================================
     FACTURA - AFISARE DOCUMENT
  ===================================================== */

  if (
    content.type ===
    'invoiceDocument'
  ) {
    return (
      <InvoiceDocument
        invoice={
          content.invoice ||
          invoice
        }
      />
    );
  }


  /* =====================================================
     IDENTIFICARE PARTI FACTURA
  ===================================================== */

  if (
    content.type ===
    'invoiceIdentifyParties'
  ) {
    return (
      <InvoiceIdentifyParties
        content={content}
        invoice={invoice}
      />
    );
  }


  /* =====================================================
     QUIZ CAMP FACTURA
  ===================================================== */

  if (
    content.type ===
    'invoiceFieldQuiz'
  ) {
    return (
      <InvoiceFieldQuiz
        content={content}
        invoice={invoice}
      />
    );
  }


  /* =====================================================
     SIMPLE SELECT
  ===================================================== */

  if (
    content.type ===
    'simpleSelect'
  ) {
    return (
      <div className="conta-primara-placeholder">

        <span>
          Simple Select
        </span>

        <h3>
          {content.question}
        </h3>

        <div className="conta-primara-placeholder-options">

          {content.options?.map(
            (
              option,
              index
            ) => (
              <button
                key={
                  `${option}-${index}`
                }
                type="button"
              >
                {option}
              </button>
            )
          )}

        </div>

      </div>
    );
  }


  /* =====================================================
     MULTIPLE SELECT
  ===================================================== */

  if (
    content.type ===
    'multipleSelect'
  ) {
    return (
      <div className="conta-primara-placeholder">

        <span>
          Multiple Select
        </span>

        <h3>
          {content.question}
        </h3>

        <div className="conta-primara-placeholder-options">

          {content.options?.map(
            (
              option,
              index
            ) => (
              <button
                key={
                  `${option}-${index}`
                }
                type="button"
              >
                {option}
              </button>
            )
          )}

        </div>

      </div>
    );
  }


  /* =====================================================
     TRUE / FALSE
  ===================================================== */

  if (
    content.type ===
    'trueFalseQuiz'
  ) {
    return (
      <div className="conta-primara-placeholder">

        <span>
          Adevarat sau Fals
        </span>

        <h3>
          {content.question}
        </h3>

        <div className="conta-primara-placeholder-options">

          <button
            type="button"
          >
            Adevarat
          </button>

          <button
            type="button"
          >
            Fals
          </button>

        </div>

      </div>
    );
  }


  /* =====================================================
     DRAG AND DROP HORIZONTAL
  ===================================================== */

  if (
    content.type ===
    'dragAndDropHorizontal'
  ) {
    return (
      <div className="conta-primara-placeholder">

        <span>
          Drag and Drop
        </span>

        <p>
          Componenta drag and drop
          va fi conectata aici.
        </p>

      </div>
    );
  }


  /* =====================================================
     ORDER SELECTION DRAG
  ===================================================== */

  if (
    content.type ===
    'orderSelectionDrag'
  ) {
    return (
      <div className="conta-primara-placeholder">

        <span>
          Ordine logica
        </span>

        <p>
          Componenta de ordonare
          va fi conectata aici.
        </p>

      </div>
    );
  }


  /* =====================================================
     FALLBACK
  ===================================================== */

  return (
    <div className="conta-primara-placeholder">

      <span>
        {content.type}
      </span>

      <p>
        Componenta pentru acest tip
        urmeaza sa fie conectata.
      </p>

    </div>
  );
};


export default RightLessonRenderer;